export default "__VITE_ASSET__DHv5ivLb__"